import { VPNS, FEATURE_ROWS } from "../data/vpns";
import { AffiliateButton } from "./Affiliate";
import { VpnLogo } from "./VpnLogo";

export const ComparisonTable = ({ vpns = VPNS, title }) => (
  <div data-testid="comparison-table">
    <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-slate-400 md:hidden">
      Swipe to see the full table →
    </p>
    <div className="overflow-x-auto">
    <table className="w-full min-w-[760px] border-collapse text-left text-sm">
      <thead>
        <tr>
          <th className="border-b-2 border-slate-200 py-4 pr-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
            {title || "Feature"}
          </th>
          {vpns.map((v) => (
            <th
              key={v.slug}
              className={`border-b-2 px-4 py-4 font-display text-base font-extrabold tracking-tight ${
                v.slug === "nordvpn"
                  ? "border-[#4687FF] bg-[#4687FF]/[0.06] text-[#0F172A]"
                  : "border-slate-200 text-[#0F172A]"
              }`}
            >
              <span className="flex items-center gap-2.5">
                <VpnLogo vpn={v} size={36} />
                {v.name}
                {v.slug === "nordvpn" && (
                  <span className="rounded-full bg-[#4687FF] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
                    #1
                  </span>
                )}
              </span>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {FEATURE_ROWS.map((row) => (
          <tr key={row.key} className="group">
            <td className="border-b border-slate-100 py-3.5 pr-4 font-semibold text-slate-500">{row.label}</td>
            {vpns.map((v) => (
              <td
                key={v.slug}
                className={`border-b px-4 py-3.5 ${
                  v.slug === "nordvpn"
                    ? "border-slate-100 bg-[#4687FF]/[0.06] font-semibold text-[#0F172A]"
                    : "border-slate-100 text-slate-600"
                }`}
              >
                {v.features[row.key]}
              </td>
            ))}
          </tr>
        ))}
        <tr>
          <td className="py-5 pr-4" />
          {vpns.map((v) => (
            <td key={v.slug} className={`px-4 py-5 ${v.slug === "nordvpn" ? "bg-[#4687FF]/[0.06]" : ""}`}>
              <AffiliateButton
                href={v.link}
                testId={`table-cta-${v.slug}`}
                variant={v.slug === "nordvpn" ? "primary" : "outline"}
                className="!px-4 !py-2 !text-xs"
              >
                Visit
              </AffiliateButton>
            </td>
          ))}
        </tr>
      </tbody>
    </table>
    </div>
  </div>
);
